import Button from "../customComponents/Button";
import Paper from "../widgets/Paper";
import InputText from "../customComponents/InputText";
import Select from "../customComponents/Select";
import { useEffect, useState } from "react";
import UploadHotel from "../customComponents/UploadHotel";
import RadioButton from "../customComponents/RadioButton";
import DatePicker from "../customComponents/DatePicker";
import { post } from "../utils/api";
import { useNavigate } from "react-router-dom";
import { useLocation } from "react-router-dom";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import SearchSelect from "../customComponents/SerachSelect";
import { use } from "react";
import useRepricePrompt from "./hooks/useRepricePrompt";


const AddAddons = () => {
  const navigate = useNavigate();
  const { promptReprice, RepriceModal } = useRepricePrompt();
  const location = useLocation();
  const editData = location.state?.editData;
  const isEditMode = !!editData;

  const [selectedStartDate, setSelectedStartDate] = useState(
    editData?.seasonstart ? new Date(editData.seasonstart) : new Date()
  );
  const [selectedEndDate, setSelectedEndDate] = useState(
    editData?.seasonend ? new Date(editData.seasonend) : new Date()
  );
  const [selectedValue, setSelectedValue] = useState("single");
  const [showSeasonalFields, setShowSeasonalFields] = useState(false);

  const [addonOptions, setAddonOptions] = useState([]);
  const [addonItem, setAddonItem] = useState("");
  const [itemName, setItemName] = useState("");
  const [totalPrice, setTotalPrice] = useState("");
  const [noOfPax, setNoOfPax] = useState("");
  const [addonPrice, setAddonPrice] = useState("");
  const [pricePerHead, setPricePerHead] = useState("");
  const [seasonalPrice, setSeasonalPrice] = useState("");
  const [selectedAddon, setSelectedAddon] = useState();
  const [addonid, setAddonId] = useState(localStorage.getItem("addonid"));
  const [addon, setAddon] = useState();
  const [addonType, setAddonType] = useState();

  const handleGetAddon = async () => {

    if(isEditMode==true){
    if (!addonid) {
      toast.error("Addon ID is missing");
      return;
    }

    try {
      const response = await post("/getAddonById", { addonid });

      if (!response.status) {
        toast.error("Error loading addon");
        return;
      }

      const data = response.data[0];
       
      setItemName(data.itemname);
      setTotalPrice(data.totalprice || "");
      setNoOfPax(data.noofpax || "");
      setAddonPrice(data.addonprice || "");
      setPricePerHead(data.priceperhead || "");
      setSeasonalPrice(data.season_priceperhead || "");
      setSelectedAddon({ value: data.addonitem, label: data.addonitem });
      if (data.seasonstart) {
        setSelectedStartDate(new Date(data.seasonstart));
      } else {
        setSelectedStartDate(null);
      }

      if (data.seasonend) {
        setSelectedEndDate(new Date(data.seasonend));
      } else {
        setSelectedEndDate(null);
      }
    } catch (error) {
      console.error("Error fetching addon:", error);
      toast.error("Error loading addon");
    }
  }
  };



  useEffect(() => {
    handleGetAddon();
    handleAddonSelect(); 
  
  }, []);
 
  const handleRadioChange = (event) => {
    setSelectedValue(event.target.value);
  };

  const handleStartDateChange = (date) => {
    setSelectedStartDate(date);
  };

  const handleEndDateChange = (date) => {
    setSelectedEndDate(date);
  };

  const handleAddonSelect = async () => {
    try {
      const response = await post("/getOptionList", { type: "addons" });
      setAddonOptions(response.data);
   
    } catch (error) {
      console.error("Error fetching addon options:", error);
      toast.error("Error loading addon options");
    }
  };


  useEffect(() => {

    if (selectedAddon) {
      const selectedAddonValue = selectedAddon.value;
      const seasonalAddons = [
      "Sightseeing",
      "1 time Snacks",
      "2 time Snacks",
      "Gift",
      "Extra Breakfast",
      "Extra Lunch",
      "Extra Dinner",
      "Insurance",
      "DMC",
      "Visa"
      ];
      const isSeasonalAddon = seasonalAddons.some((addon) =>
      selectedAddonValue.includes(addon)
      );
      setShowSeasonalFields(isSeasonalAddon);

      // Set addon type based on whether it's seasonal or not
      if (isSeasonalAddon) {
      setAddonType("pph");
      } else {
      setAddonType("tp");
      }
    }
    

  }, [selectedAddon]);

  const validateFields = () => {
    if (!selectedAddon) {
      toast.error("Please select an addon item");
      return false;
    }


    if (!itemName) {
      toast.error("Please enter an item name");
      return false;
    }
    

    if (!noOfPax || isNaN(noOfPax) || noOfPax <= 0) {
      toast.error("Please enter a valid number of pax");
      return false;
    }
    if (addonType === "pph" && !pricePerHead) {
      toast.error("Please enter a valid price per head");
      return false;
    }

    if (!addonPrice || isNaN(addonPrice) || addonPrice <= 0) {
      toast.error("Please enter a valid price per head");
      return false;
    }




    // if (showSeasonalFields) {
    //   if (!selectedStartDate || !selectedEndDate) {
    //     toast.error("Please select both season start and end dates");
    //     return false;
    //   }

    //   if (selectedStartDate > selectedEndDate) {
    //     toast.error("Season end date must be after start date");
    //     return false;
    //   }

    //   if (!seasonalPrice || isNaN(seasonalPrice) || seasonalPrice <= 0) {
    //     toast.error("Please enter a valid seasonal price per head");
    //     return false;
    //   }
    // }

    return true;
  };

  const handleSave = async () => {
    if (!selectedAddon?.value) {
      toast.error("Please select an addon item");
      return;
    }


    if (!itemName) {
      toast.error("Please enter an item name");
      return;
    }
    if (!totalPrice || isNaN(totalPrice) || totalPrice <= 0) {
      toast.error("Please enter a valid total price");
      return;
    }

    if (addonType === "pph" ) {
    if (!noOfPax || isNaN(noOfPax) || noOfPax <= 0) {
      toast.error("Please enter a valid number of pax");
      return;
    }
    
    if (!addonPrice) {
      toast.error("Please enter price per head");
      return;
    }
  }

    // if (showSeasonalFields) {
    //   if (!selectedStartDate || !selectedEndDate) {
    //     toast.error("Please select seasonal dates");
    //     return;
    //   }
    //   if (!seasonalPrice) {
    //     toast.error("Please enter seasonal price");
    //     return;
    //   }
    // }

    const payload = {
      type: isEditMode ? "update" : "insert",
      addonitem: selectedAddon?.value || "",
      addonprice: addonPrice,
      itemname: itemName, 
      totalprice: totalPrice,
      noofpax: noOfPax, 
      seasonstart: showSeasonalFields && selectedStartDate 
        ? selectedStartDate.toISOString() 
        : null,

      seasonend: showSeasonalFields && selectedEndDate 
        ? selectedEndDate.toISOString() 
        : null,
      season_priceperhead: showSeasonalFields ? seasonalPrice : null,
      addonid: isEditMode ? editData.addonid : selectedAddon?.id || null,
    };

    console.log("Payload:", payload);
    try {
      const response = await post("/addAddon", payload);
      if (response.status) {
        toast.success(
          isEditMode ? "Addon updated successfully" : "Addon saved successfully"
        );
        promptReprice(response, () =>
          setTimeout(() => {
            navigate(-1);
          }, 1000)
        );
      } else {
        toast.error("Error: Non-successful response");
      }
    } catch (error) {
      toast.error(isEditMode ? "Error updating addon" : "Error saving addon");
    }
  };

  const handleNavigateCancel = () => {
    navigate(-1);
  };

  
  

  useEffect(() => {
    if (totalPrice && noOfPax) {
      const pricePerHead = parseFloat(totalPrice) / parseInt(noOfPax, 10);
      setAddonPrice(pricePerHead.toFixed(2)); // Set the value with 2 decimal places
    } else {
      setAddonPrice(""); // Clear the value if inputs are invalid
    }
  }, [totalPrice, noOfPax]);

  return (
    <div>
      {RepriceModal}
      <div className="block md:flex lg:flex justify-between">
        <div>
          <h2 className="text-primary-black text-[24px] font-semibold">
              Addons
          </h2>
          <p className="text-[12px]">
            <span className="font-bold">Addons</span> /
            <span className="font-regular">
              {isEditMode ? "Edit Addon" : "Add Addon"}
            </span>
          </p>
        </div>

        <div className="flex mt-4 justify-end gap-4">
          <Button
            type="primary"
            label={isEditMode ? "Update" : "Save"}
            onClick={handleSave}
          />
          <Button
            type="secondary"
            label="Cancel"
            onClick={handleNavigateCancel}
          />
        </div>
      </div>

      <Paper className="my-8 pt-6 pb-6">
        <h1 className="text-[16px] font-semibold">Upload Type</h1>
        <div className="mt-4 space-y-4">
          <RadioButton
            name="customRadio"
            value="single"
            checked={selectedValue === "single"}
            onChange={handleRadioChange}
            label="Single Upload"
          />
          <RadioButton
            name="customRadio"
            value="bulk"
            checked={selectedValue === "bulk"}
            onChange={handleRadioChange}
            label="Bulk Upload"
            className={"ml-4"}
          />
        </div>

       

        {selectedValue === "single" && (
          <Paper className="my-8 border">
            <h1 className="text-[20px] font-bold mb-4">Addons Details</h1>
            <div className="grid grid-flow-row-dense grid-cols-1 md:grid-cols-2 lg:grid-cols-5 gap-4">
              <div>
                <label className="text-[16px] font-semibold mb-2">
                  Addon Item <span className="text-red-500">*</span>
                </label>
              
                <SearchSelect
                  options={addonOptions}
                  placeholder="Select..."
                  value={addonOptions.find(
                    (option) => option.value === selectedAddon?.value
                  )}
                  onChange={(selectedOption) => {
                    setSelectedAddon(selectedOption);
                    setAddonItem(selectedOption.value);
                  }}
                  onClick={handleAddonSelect}
                />
              </div>
              <div>
                <label className="text-[16px] font-semibold mb-2">
                  Item Name <span className="text-red-500"></span>
                </label>
                <InputText
                  placeholder="Enter Name..."
                  value = {itemName}
                  onChange={(e) => setItemName(e.target.value
                  )}
                />
              </div>
              <div>
                <label className="text-[16px] font-semibold mb-2">
                  Total Price <span className="text-red-500"></span>
                </label>
                <InputText
                  placeholder="Enter Price..."
                 value = {totalPrice}
                  onChange={(e) => setTotalPrice(e.target.value
                  )}
                />
              </div>
{addonType === "pph" && 
<>
              <div>
                <label className="text-[16px] font-semibold mb-2">
                  No. of Pax <span className="text-red-500"></span>
                </label>
                <InputText
                  placeholder="Enter Number..."
                 value = {noOfPax}
                  onChange={(e) => setNoOfPax(e.target.value
                  )}
                />
              </div>
              <div>
                <label className="text-[16px] font-semibold mb-2">
                  Price Per Head <span className="text-red-500">*</span>
                </label>
                <InputText
                  placeholder="Enter Amount..."
                  value={addonPrice}
                  onChange={(e) => setAddonPrice(e.target.value)}
                />
              </div>
              </>
}

            </div>
            
          </Paper>
        )}
        <ToastContainer />
        {selectedValue === "bulk" && (
          <Paper className="my-8 border">
            <h1 className="text-[20px] font-bold mb-4">Upload File</h1>
            <UploadHotel />
          </Paper>
        )}
      </Paper>
    </div>
  );
};

export default AddAddons;
